<template>
  <v-main :class="(celebrationId) ? 'pa-0' : ''">
    <v-container fluid :class="(celebrationId) ? 'pa-0' : ''">
      <v-card outlined class="elevation-0 pa-3 mt-2">
        <v-row>
          <v-col style="padding-bottom: 0">
            <b>Estatuto</b>
          </v-col>
          <v-col cols="auto" style="padding-bottom: 0">
            <v-btn fab text small dark class="text-center" color="primary" @click="documentFormShow = true">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" md="auto" class="pt-0 text-right">
            <span class="caption">Assinantes</span>
            <br/>
            <v-chip small :color="loading ? 'mute' : participantsQty > documentAssinedQty ? 'error' : 'success'">
              {{ loading ? 'Carregando...' : documentAssinedQty + '/' + joinedQty }}
            </v-chip>
          </v-col>
          <v-col cols="4" md="auto" class="pt-0 text-right">
            <span class="caption">Enviados</span>
            <br/>
            <v-chip small :color="loading ? 'mute' : participantsQty > documentSentQty ? 'error' : 'success'">
              {{ loading ? 'Carregando...' : documentSentQty + '/' + joinedQty }}
            </v-chip>
          </v-col>
          <v-col cols="4" md="auto" class="pt-0 text-right">
            <span class="caption">Arrecadando</span>
            <br/>
            <v-chip small :color="loading ? 'mute' : participantsQty > joinedQty ? 'warning' : 'success'">
              {{ loading ? 'Carregando...' : joinedQty + '/' + participantsQty }}
            </v-chip>
          </v-col>
          <v-col cols="12" md="auto" class="pt-0">
            <span class="caption">Link do Estatuto</span>
            <br/>
            <template v-if="loading">Carregando...</template>
            <a v-else-if="documentLink" :href="documentLink" target="_blank">{{ documentLink }}</a>
            <template v-else>Sem estatuto</template>
          </v-col>
        </v-row>
      </v-card>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n3">Assinaturas</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex align-center pr-3">
          <div style="height: 25px;">
            <v-checkbox
              label="Apenas arrecadantes"
              v-model="onlyJoineds"
              color="primary"
            ></v-checkbox>
          </div>
        </div>
        <div class="d-flex align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
        </div>
        <v-btn class="ml-2 mr-n4" text color="primary" @click="downloadSheet">
          <v-icon left>mdi-file-excel-outline</v-icon> Exportar
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        no-data-text="Nenhum participante arrecadando"
        no-results-text="Sem participantes com essa busca"
        loading-text="Carregando..."
        :loading="loading"
        :disable-pagination="true"
        :hide-default-footer="true"
        :search="quicksearch"
      >
      <template v-slot:item.name="{ item }">
          {{ item.name }}
          <br />
          ({{ item.email }})
        </template>
        <template v-slot:item.amountToPay="{ item }">
          <div style="white-space: nowrap;">{{ item.amountToPay | price }}</div>
        </template>
        <template v-slot:item.totalPaid="{ item }">
          <div style="white-space: nowrap;">{{ item.totalPaid | price }}</div>
        </template>
        <template v-slot:item.totalLate="{ item }">
          <div style="white-space: nowrap;">{{ item.totalLate | price }}</div>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip small :color="item.statusColor">{{ item.status }}</v-chip>
        </template>
        <template v-slot:item.signedIn="{ item }">
          <div v-if="item.signedIn" style="white-space: nowrap;">{{ item.signedIn | moment('DD/MM/YYYY') }}</div>
          <div v-else-if="item.link">
            <v-chip class="mr-3" @click="copyToClipboard(item.link)">
              Copiar link <v-icon size="15px" class="ml-2">mdi-content-copy</v-icon>
            </v-chip>
          </div>
        </template>
      </v-data-table>
    </v-container>
    <document-dialog-form
      :settings="{ document }"
      :celebrationId="celebrationId"
      v-if="documentFormShow"
      @canceled="documentFormShow = false"
      @ok="formSettingsOk"
    ></document-dialog-form>
  </v-main>
</template>

<script>
import axios from 'axios'
import XLSX from 'xlsx'

import DocumentDialogForm from '@/components/DocumentDialogForm'
import Quicksearch from '@/components/Quicksearch'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'celebrationDocument',
  components: {
    DocumentDialogForm,
    Quicksearch
  },
  props: ['celebrationId'],
  data: () => ({
    loading: false,
    document: null,
    documentFormShow: false,
    onlyJoineds: true,
    quicksearch: '',
    headers: [
      {
        text: 'Nome',
        value: 'name'
      },
      {
        text: 'Arrecadações',
        value: 'fundraisings'
      },
      {
        text: 'Meta',
        align: 'right',
        value: 'amountToPay'
      },
      {
        text: 'Pago',
        align: 'right',
        value: 'totalPaid'
      },
      {
        text: 'Atrasado',
        align: 'right',
        value: 'totalLate'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Assinado em',
        value: 'signedIn'
      }
    ],
    participants: [],
    joineds: [],
    signatures: [],
    exceptionalSignatures: {}
  }),
  computed: {
    ...mapGetters(['isBackoffice']),
    items () {
      const items = []
      if (this.participants) {
        for (const i in this.participants) {
          const participant = this.participants[i]
          if (!['fala@heppi.com.br', 'promoover.andrea@gmail.com'].includes(participant.email)) {
            const joineds = this.joineds.filter(j => j.participantId === participant.id) || []
            const fundraisings = joineds.map(j => j.name)
            let amountToPay = 0
            let totalLate = 0
            let totalPaid = 0
            let joinedCreatedAt = ''
            for (const j in joineds) {
              if (joineds[j].amountToPay) amountToPay += joineds[j].amountToPay
              if (joineds[j].totalLate) totalLate += joineds[j].totalLate
              if (joineds[j].totalPaid) totalPaid += joineds[j].totalPaid
              if (joineds[j].createdAt) joinedCreatedAt = (joinedCreatedAt && parseInt(joinedCreatedAt) < parseInt(joineds[j].createdAt)) ? joinedCreatedAt : joineds[j].createdAt
            }
            const exceptionalSigned = this.exceptionalSignatures[participant.id] || ''
            const signature = this.signatures.find(e => e.email === participant.email || e.email === exceptionalSigned)
            items.push({
              id: participant.id,
              name: participant.name || '',
              email: participant.email || '',
              phone: participant.phone || '',
              document: participant.document || '',
              createdAt: participant.createdAt || '',
              joinedCreatedAt,
              fundraisings: fundraisings.length > 0 ? fundraisings.join(', ') : '',
              amountToPay,
              totalLate,
              totalPaid,
              status: (signature && signature.status) || 'Não enviado',
              statusColor: (signature && signature.statusColor) || 'error',
              signedIn: (signature && signature.signedIn) || '',
              link: (signature && signature.link && signature.link.short_link) || ''
            })
          }
        }
      }
      return items
    },
    filteredItems () {
      return this.items.filter(item => {
        if (this.onlyJoineds) {
          return item.amountToPay && item.fundraisings
        } else {
          return true
        }
      })
    },
    documentLink () {
      if (this.document) {
        return `https://painel.autentique.com.br/documentos/${this.document}`
      }
      return ''
    },
    documentAssinedQty () {
      return this.items.filter(i => !!i.signedIn).length || 0
    },
    documentSentQty () {
      return this.items.filter(i => i.statusColor !== 'error').length || 0
    },
    joinedQty () {
      return this.items.filter(i => !!i.fundraisings && i.amountToPay > 0).length || 0
    },
    participantsQty () {
      return this.items.length || 0
    },
    dataToExport () {
      const dataToExport = [[
        ...(this.isBackoffice ? ['ID Participante'] : []),
        'Nome',
        'CPF/CNPJ',
        'Email',
        'Telefone',
        'Entrou na turma',
        'Iniciou na arrecadação',
        'Arrecadações',
        'Meta',
        'Total Pago',
        'Atrasado',
        'Status',
        'Assinado em',
        'Link'
      ]]
      for (const i in this.items) {
        const item = this.items[i]
        dataToExport.push([
          ...(this.isBackoffice ? [item.id] : []),
          item.name,
          item.document,
          item.email,
          item.phone,
          (item.createdAt && this.$moment(item.createdAt, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm')) || '',
          (item.joinedCreatedAt && this.$moment(item.joinedCreatedAt, 'x').format('DD/MM/YYYY HH:mm')) || '',
          item.fundraisings,
          item.amountToPay,
          item.totalPaid,
          item.totalLate,
          item.status,
          (item.signedIn && this.$moment(item.signedIn, 'YYYY-MM-DD[T]HH:mm[.000Z]').subtract(3, 'hours').format('DD/MM/YYYY HH:mm')) || '',
          item.link
        ])
      }
      return dataToExport
    }
  },
  watch: {
    // params () {
    //   this.getData()
    // }
  },
  methods: {
    ...mapActions(['copyToClipboard']),
    formSettingsOk () {
      this.getData()
      this.documentFormShow = false
    },
    getData () {
      this.loading = true
      this.$firestore.collection('settings').doc(this.celebrationId).get()
        .then((snapshot) => {
          const data = snapshot.data()
          this.document = (data && data.document) || null
          this.exceptionalSignatures = (data && data.signatures) || {}
          this.signatures = []

          if (this.document) {
            this.$store.dispatch('firebaseApi', `autentiquedoc?documentId=${this.document}`)
              .then(response => {
                if (response.signatures) {
                  this.signatures = [...this.signatures, ...response.signatures.map(s => {
                    let status = ''
                    if (s.signed) status = 'Assinado'
                    else if (s.viewed) status = 'Visualizado'
                    else if (s.email_events && s.email_events.opened) status = 'Email aberto'
                    else if (s.email_events && s.email_events.delivered) status = 'Email entregue'
                    else if (s.email_events && s.email_events.refused) status = 'Email com erro'

                    let statusColor = ''
                    if (s.signed) statusColor = 'success'
                    else if (s.email_events && s.email_events.refused) statusColor = 'error'
                    else statusColor = 'warning'

                    return {
                      id: s.publicId,
                      email: s.email,
                      link: s.link || '',
                      status,
                      statusColor,
                      signedIn: s.signed ? s.signed.created_at : ''
                    }
                  })]
                }
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.loading = false
          }

          if (data.alternativeDocuments && data.alternativeDocuments.length > 0) {
            for (const index in data.alternativeDocuments) {
              this.$store.dispatch('firebaseApi', `autentiquedoc?documentId=${data.alternativeDocuments[index]}`)
                .then(response => {
                  if (response.signatures) {
                    this.signatures = [...this.signatures, ...response.signatures.map(s => {
                      let status = ''
                      if (s.signed) status = 'Assinado'
                      else if (s.viewed) status = 'Visualizado'
                      else if (s.email_events && s.email_events.opened) status = 'Email aberto'
                      else if (s.email_events && s.email_events.delivered) status = 'Email entregue'
                      else if (s.email_events && s.email_events.refused) status = 'Email com erro'

                      let statusColor = ''
                      if (s.signed) statusColor = 'success'
                      else if (s.email_events && s.email_events.refused) statusColor = 'error'
                      else statusColor = 'warning'

                      return {
                        id: s.publicId,
                        email: s.email,
                        link: s.link || '',
                        status,
                        statusColor,
                        signedIn: s.signed ? s.signed.created_at : ''
                      }
                    })]
                  }
                })
            }
          }
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Não foi possivel trazer as configurações, tente novamente' })
          this.loading = false
        })
    },
    getParticipants (page) {
      axios.get('participants?page[size]=30&page[number]=' + (page || 1) + '&&filter[celebration_id]=' + this.celebrationId)
        .then(response => {
          if (!page) this.participants = []
          if (response.data && response.data.data) {
            for (const i in response.data.data) {
              const participant = response.data.data[i]
              this.participants.push({
                id: participant.id || '',
                createdAt: participant.created_at || '',
                name: (participant.customer && participant.customer.name) || '',
                phone: (participant.customer && participant.customer.phone_number) || '',
                email: (participant.customer && participant.customer.email) || '',
                document: (participant.customer && participant.customer.person_document) || ''
              })
            }
          }
          if (response.data.meta.last_page > 1) {
            if (!page) this.getParticipants(2)
            else if (page < response.data.meta.last_page) this.getParticipants(page + 1)
          }
        })
        .catch(() => {
          this.participants = []
        })
    },
    getJoineds () {
      axios.get('fundraisings?page[size]=30&page[number]=1&&filter[celebration_id]=' + this.celebrationId)
        .then(resp => {
          if (resp.data && resp.data.data) {
            this.joineds = []
            for (const i in resp.data.data) {
              const fundraisingId = resp.data.data[i].id
              axios.get('fundraisings/' + fundraisingId)
                .then(response => {
                  if (response.data && response.data.participants) {
                    for (const i in response.data.participants) {
                      const joined = response.data.participants[i]
                      this.joineds.push({
                        id: joined.joined_id || '',
                        name: response.data.name || '',
                        participantId: joined.id || '',
                        createdAt: this.$moment(joined.joined_created_at, 'YYYY-MM-DD HH:mm:ss').format('x') || '',
                        amountToPay: joined.amount_to_pay || 0,
                        totalLate: joined.total_late || 0,
                        totalPaid: joined.total_paid || 0
                      })
                    }
                  }
                })
                .catch(() => {
                  this.joineds = []
                })
            }
          }
        })
        .catch(() => {
          this.joineds = []
        })
    },
    downloadSheet () {
      const workbook = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet(this.dataToExport)
      XLSX.utils.book_append_sheet(workbook, ws, 'Estatuto')
      XLSX.writeFile(workbook, 'Estatuto.xlsx')
    }
  },
  created () {
    this.getData()
    this.getParticipants()
    this.getJoineds()
  }
}
</script>
